import { environment } from "@env/environment";
import { type IGetUserModulesResponse } from "@interfaces/modules/IGetModulesResponse";

import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class ModulesService {
  private httpClient = inject(HttpClient);

  getUserAccessibleModules(tenant: string) {
    return this.httpClient.get<IGetUserModulesResponse>(
      `${environment.API_URL}/api/modules/${tenant}/user-accessible`
    );
  }
}
